<template lang="pug">
img.image(:src="transformedSrc")
</template>

<script>
import cloudinary from 'cloudinary-core';

export default {
  name: 'cl-img',
  computed: {
    transformedSrc() {
      if (this.clId === null) return this.fallback;
      const transform = Object.assign({}, this.defaultTranformation, this.transform);
      return this.cloudinary.url(this.clId, transform);
    },
  },
  created() {
    this.cloudinary = cloudinary.Cloudinary.new({
      cloud_name: process.env.VUE_APP_CLOUDINARY_CLOUD_NAME,
    });
  },
  data() {
    return {
      cloudinary: null,
      defaultTranformation: {
        quality: 'auto',
        fetch_format: 'auto',
        crop: 'fit',
      },
    };
  },
  props: {
    clId: {
      type: String,
      default: null,
    },
    fallback: {
      type: String,
      default: null,
    },
    transform: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
</style>
